import Cookie from 'formstone/jquery/cookie';

window.SiteReady(($) => {

  let $html = $('html');
  let $scrim = $('.js-scrim');
  let show = $html.hasClass('js-show_scrim');

  function playScrim() {
    $.cookie('set', 'scrim-viewed', 'true', {
      path: '/',
      expires: (1000 * 60 * 60 * 24), // 24 hours
    });

    setTimeout(() => {
      $html.addClass('scrim_1');

      setTimeout(() => {
        $html.addClass('scrim_2');

        setTimeout(() => {
          $html.addClass('scrim_3');
        }, 1000);

      }, 1000);

    }, 500);
  }

  if (show && $scrim.length) {
    playScrim();
  }

  window.playScrim = () => {
    $scrim.hide();
    $html.removeClass('scrim_1 scrim_2 scrim_3');

    setTimeout(() => {
      $scrim.removeAttr('style');
      $html.addClass('js-show_scrim');
      playScrim();
    }, 100);
  };

});